import { useUser } from "@ip-contexts/user-context";
import { MainWithSidebar } from "@ip-layout";
import { H1 } from "@ip-widgets/Tailwind/common/header";
import { VNavWithIcon } from "@ip-widgets/Tailwind/common/vertical-navigation";

export default function General() {
  const {
    state: { user, status },
  } = useUser();

  return (
    <MainWithSidebar
      main={<Main user={user} status={status} />}
      sidebar={<VNavWithHeaderAndIcon />}
    />
  );
}

const Main = ({ user, status }: any) => {
  if (!user || status !== "resolved") {
    return <div>Loading</div>;
  }

  const { email, name } = user;

  return (
    <div className="w-10/12 h-full">
      <div className="px-0 pt-12 mx-auto max-w-7xl md:px-12 lg:px-12">
        <div className="sm:grid sm:grid-cols-5 sm:items-start sm:gap-4 sm:pt-1">
          <label className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
            Name
          </label>
          <div className="mt-1 sm:col-span-2 sm:mt-0">
            <p className="mt-2 text-sm text-gray-500">{name}</p>
          </div>
        </div>
        <div className="sm:grid sm:grid-cols-5 sm:items-start sm:gap-4 sm:pt-1">
          <label className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
            Email
          </label>
          <div className="mt-1 sm:col-span-2 sm:mt-0">
            <p className="mt-2 text-sm text-gray-500">{email}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const VNavWithHeaderAndIcon = () => {
  return (
    <div className="flex flex-col flex-grow pt-5 pb-4 overflow-y-auto bg-white border-r border-gray-200">
      <div className="flex items-center flex-shrink-0 px-8">
        <H1 text={"Settings"} />
      </div>
      <div className="flex flex-col flex-grow mt-5">
        <VNavWithIcon currentPage="/settings" />
      </div>
    </div>
  );
};
